<template>
    <el-select
        v-model="valueCpd"
        multiple
        collapse-tags
        filterable
        placeholder="请选择"
        :popper-append-to-body="false"
    >
        <li class="el-select-dropdown__item" @click="allSelectHandle" :class="{
            selected: allChecked
        }">
            <span>全选</span>
        </li>
        <el-option
            v-for="item in options"
            :key="item[props.value]"
            :label="item[props.label]"
            :value="item[props.value]"
        >
        </el-option>
    </el-select>
</template>

<script>
export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: Array,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        props: {
            type: Object,
            default(){
                return {
                    label: 'label',
                    value: 'value'
                }
            }
        }
    },
    computed: {
        valueCpd: {
            get(){
                return this.value
            },
            set(val){
                this.$emit('change', val)
            }
        },
        allChecked(){
            return this.value.length != 0 && this.value.length == this.options.length
        }
    },
    methods: {
        allSelectHandle(){
            if(this.allChecked){
                this.$emit('change', [])
            }else{
                this.$emit('change', this.options.map(item => item[this.props.value]))
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/MultipleSelect/index.vue